import HttpRequest from "../../utilities/httpRequest";
import { AthleteType } from "../../utilities/constants";
import {
  addPatient,
  getAilingAthletes,
  getAthletesWithoutParams,
  getCases,
  getChronicAthletes,
  getClosedCases,
  getHealthyAthletes,
  getInjuredAthletes,
  getOpenCases,
  getPatientById,
  getRecoveringAthletes,
  patientImageAnalysisStore,
  patientQuestionAnswer,
  patientSymptom,
  searchPatients,
  setClinicalSummary,
  setVikrutiData,
  setBloodReportData,
  setVikrutiAverageData,
  setSymptomsData,
} from "./PatientActions";
import {
  hideLoader,
  showLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";

/**
 * function to get athletes without params
 * @param id: id for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getPatientsWithoutParamsRequest = (id, type, data = {}) => {
  const offset = data.page * data.rowsPerPage;
  const limit = data.rowsPerPage;

  const searchData = { active: "1" };

  if (type === AthleteType.USER) searchData.userId = id;

  if (data.searchData) {
    if (data.searchData.name) searchData.name = data.searchData.name;
    if (data.searchData.phone) searchData.phone = data.searchData.phone;
  }

  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        const resData = res.data.data;
        dispatch(hideLoader());
        dispatch(getAthletesWithoutParams(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get recovering athletes
 * @param id: id for api request
 * @param sortBy: sortBy for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getRecoveringPatientsRequest = (teamId, data) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = { status: "RECOVERING", teamId };

  if (data.searchData) {
    if (data.searchData.name) searchData.name = data.searchData.name;
    if (data.searchData.phone) searchData.phone = data.searchData.phone;
  }

  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        dispatch(hideLoader());
        dispatch(getRecoveringAthletes(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get ailing athletes
 * @param id: id for api request
 * @param sortBy: sortBy for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getAilingPatientsRequest = (teamId, data) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = { status: "AILING", teamId };

  if (data.searchData) {
    if (data.searchData.name) searchData.name = data.searchData.name;
    if (data.searchData.phone) searchData.phone = data.searchData.phone;
  }

  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        dispatch(hideLoader());
        dispatch(getAilingAthletes(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get chronic athletes
 * @param id: id for api request
 * @param sortBy: sortBy for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getChronicPatientsRequest = (teamId, data) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = { status: "CHRONIC", teamId };

  if (data.searchData) {
    if (data.searchData.name) searchData.name = data.searchData.name;
    if (data.searchData.phone) searchData.phone = data.searchData.phone;
  }

  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        dispatch(hideLoader());
        dispatch(getChronicAthletes(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};
/**
 * function to add athlete
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const addPatientRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = "patients";

    return new HttpRequest(dispatch, url, "post", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("New user added successfully", "success"));

        dispatch(addPatient(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar(
            "New user not added successfully, try again later",
            "error"
          )
        );
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get athlete by id
 * @param id: id for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getPatientByIdRequest = (id) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients/${id}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getPatientById(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        if (error.response.data.error) {
          dispatch(showSnackbar(error.response.data.error, "error"));
        }
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get cases
 * @param teamId: teamId for api request
 * @param patientId: patientId for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getCasesRequest = (teamId, patientId) => {
  const data = {
    // teamId: teamId,
    status: "ALL",
    patientId: patientId,
  };
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patientCase?searchData=${JSON.stringify(data)}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getCases(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get open cases
 * @param teamId: teamId for api request
 * @param patientId: patientId for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getOpenCasesRequest = (teamId, patientId) => {
  const data = {
    // teamId: teamId,
    status: "OPEN",
    patientId: patientId,
  };
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patientCase?searchData=${JSON.stringify(data)}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getOpenCases(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get closed cases
 * @param teamId: teamId for api request
 * @param patientId: patientId for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getClosedCasesRequest = (teamId, patientId) => {
  const data = {
    // teamId: teamId,
    status: "CLOSED",
    patientId: patientId,
  };
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patientCase?searchData=${JSON.stringify(data)}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getClosedCases(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get health score of user
 * @returns {function(*=): Promise<unknown>}
 * @param mobileNumber
 */
export const getHealthScoreRequest = (mobileNumber) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `/score_recommendations?user_id=${mobileNumber}`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(process.env.REACT_APP_MAD_MEDICINE_API_URL)
      .then(
        (res) => {
          dispatch(hideLoader());
          return Promise.resolve(res.data.recommendations);
        },
        (error) => {
          dispatch(hideLoader());
          return Promise.reject(error);
        }
      );
  };
};

/**
 * function to get a single score label (e.g. Prakriti) from the mad-medicine API
 * @param mobileNumber user_id
 * @param scoreName e.g. "Prakriti"
 * @returns {function(*=): Promise<string|null>} the label value, or null
 */
export const getScoreLabelRequest = (mobileNumber, scoreName) => {
  return (dispatch) => {
    const url = `/score_labels?user_id=${mobileNumber}&score_name=${scoreName}`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(process.env.REACT_APP_MAD_MEDICINE_API_URL)
      .then(
        (res) =>
          Promise.resolve(
            (res.data && res.data.score_labels && res.data.score_labels[scoreName]) ||
              null
          ),
        (error) => Promise.reject(error)
      );
  };
};

// Strapi content-API base. Must point at the Strapi `/api` root,
// e.g. http://localhost:1337/api or https://strapi.madmachines.in/api
const STRAPI_API_URL = process.env.REACT_APP_STRAPI_API_URL;

/**
 * Fetch the Physical Assessment record for a case from Strapi.
 * GET /physical-assessments?filters[case_id][$eq]={caseId}
 * @returns the first matching record (or null if none exists)
 */
export const getPhysicalAssessmentRequest = (caseId) => {
  return (dispatch) => {
    const url = `/physical-assessments?filters[case_id][$eq]=${caseId}`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          const record = res.data && res.data.data && res.data.data[0];
          return Promise.resolve(record || null);
        },
        (error) => Promise.reject(error)
      );
  };
};

/**
 * Save the Physical Assessment for a case to Strapi. Looks up an existing record
 * for the case first, then updates it (PUT) or creates a new one (POST). This
 * lookup-then-write guarantees a single record per case (no duplicates).
 * GET  /physical-assessments?filters[case_id][$eq]={caseId}
 * PUT  /physical-assessments/{id}   (when a record exists)
 * POST /physical-assessments        (otherwise)
 */
export const savePhysicalAssessmentRequest = (caseId, payload) => {
  return (dispatch) => {
    dispatch(showLoader());
    const findUrl = `/physical-assessments?filters[case_id][$eq]=${caseId}`;
    const body = { data: payload };
    return new HttpRequest(dispatch, findUrl, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then((res) => {
        const record = res.data && res.data.data && res.data.data[0];
        if (record) {
          const id = record.documentId || record.id;
          return new HttpRequest(
            dispatch,
            `/physical-assessments/${id}`,
            "put",
            body
          ).thirdPartyIntegration(STRAPI_API_URL);
        }
        return new HttpRequest(
          dispatch,
          `/physical-assessments`,
          "post",
          body
        ).thirdPartyIntegration(STRAPI_API_URL);
      })
      .then(
        (res) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Physical assessment saved", "success"));
          return Promise.resolve(res.data);
        },
        (error) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Failed to save physical assessment", "error"));
          return Promise.reject(error);
        }
      );
  };
};

/**
 * Fetch the latest Nadi Report for a patient from Strapi. Nadi reports are keyed
 * on a plain 10-digit `patient_phone`, so we grab the most recently updated
 * record for that phone (the one whose vata/pitta/kapha the doctor sees & edits).
 * GET /nadi-reports?filters[patient_phone][$eq]={phone}&sort=updatedAt:desc&pagination[pageSize]=1
 * @returns the first matching record (or null if none exists)
 */
export const getNadiReportRequest = (phone) => {
  return (dispatch) => {
    const url = `/nadi-reports?filters[patient_phone][$eq]=${phone}&sort=updatedAt:desc&pagination[page]=1&pagination[pageSize]=1`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          const record = res.data && res.data.data && res.data.data[0];
          return Promise.resolve(record || null);
        },
        (error) => Promise.reject(error)
      );
  };
};

/**
 * Update the vata/pitta/kapha values on an existing Nadi Report record.
 * PUT /nadi-reports/{id}
 * @param {string|number} recordId Strapi documentId (v5) or numeric id (v4)
 * @param {object} payload { vata, pitta, kapha }
 */
export const saveNadiReportRequest = (recordId, payload) => {
  return (dispatch) => {
    dispatch(showLoader());
    const body = { data: payload };
    return new HttpRequest(dispatch, `/nadi-reports/${recordId}`, "put", body)
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Nadi reading saved", "success"));
          return Promise.resolve(res.data);
        },
        (error) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Failed to save Nadi reading", "error"));
          return Promise.reject(error);
        }
      );
  };
};

/**
 * Create a Nadi Report record holding just the doctor's pulse reading, for a
 * patient with no device-generated report yet. Every other field on the
 * collection is optional, so the record carries only the phone it is keyed on
 * and the three dosha values.
 * POST /nadi-reports
 * @param {string} phone plain 10-digit patient_phone
 * @param {object} payload { vata, pitta, kapha }
 * @returns the created record
 */
export const createNadiReportRequest = (phone, payload) => {
  return (dispatch) => {
    if (!phone) return Promise.reject(new Error("Missing phone"));
    dispatch(showLoader());
    const body = { data: { patient_phone: phone, ...payload } };
    return new HttpRequest(dispatch, `/nadi-reports`, "post", body)
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Nadi reading saved", "success"));
          return Promise.resolve((res.data && res.data.data) || null);
        },
        (error) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Failed to save Nadi reading", "error"));
          return Promise.reject(error);
        }
      );
  };
};

/**
 * Fetch the latest Clinical Blood Report for a patient from Strapi (keyed on the
 * plain 10-digit `patient_phone`). Used to surface the AI-highlighted lab
 * findings (`labFindings`) on the Overview tab.
 * GET /clinical-blood-reports?filters[patient_phone][$eq]={phone}&sort=updatedAt:desc&pagination[pageSize]=1
 * @returns the first matching record (or null if none exists)
 */
export const getClinicalBloodReportRequest = (phone) => {
  return (dispatch) => {
    const url = `/clinical-blood-reports?filters[patient_phone][$eq]=${phone}&sort=updatedAt:desc&pagination[page]=1&pagination[pageSize]=1`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          const record = res.data && res.data.data && res.data.data[0];
          return Promise.resolve(record || null);
        },
        (error) => Promise.reject(error)
      );
  };
};

// Latest report record for a patient in a Strapi collection (flattened fields),
// used for the report-preview highlights. Returns null when none exists.
export const getLatestStrapiReportRequest = (collection, phone) => {
  return (dispatch) => {
    if (!phone) return Promise.resolve(null);
    const url = `/${collection}?filters[patient_phone][$eq]=${phone}&sort=updatedAt:desc&pagination[page]=1&pagination[pageSize]=1`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then(
        (res) => {
          const record = (res.data && res.data.data && res.data.data[0]) || null;
          // Strapi v4 nests fields under `attributes`; v5 keeps them flat.
          return Promise.resolve(record ? record.attributes || record : null);
        },
        (error) => Promise.reject(error)
      );
  };
};


export const getDxaiReportUrlRequest = (reportId) => {
  return (dispatch) => {
    if (!reportId) return Promise.reject(new Error("Missing report id"));
    return new HttpRequest(dispatch, `reports/${reportId}/url`, "get")
      .send()
      .then(
        (res) => Promise.resolve((res.data && res.data.url) || null),
        (error) => Promise.reject(error)
      );
  };
};

// No input document resolved — same shape as a successful lookup.
const EMPTY_REPORT_INPUT = {
  url: null,
  available: false,
  contentType: null,
  fileName: null,
};

/**
 * Resolve a temporary url for the input document a report was generated from
 * (e.g. the lab report the patient uploaded for their blood report). The upload
 * can be a PDF or an image, so `contentType` / `fileName` say what the file is.
 * The backend confirms the file is actually stored, so `available` is false for
 * a report that never had an input rather than a link that 404s.
 * GET /reports/{reportId}/input-url
 * @returns {Promise<{ url: string|null, available: boolean, contentType: string|null, fileName: string|null }>}
 */
export const getDxaiReportInputUrlRequest = (reportId) => {
  return (dispatch) => {
    if (!reportId) return Promise.resolve(EMPTY_REPORT_INPUT);
    return new HttpRequest(dispatch, `reports/${reportId}/input-url`, "get")
      .send()
      .then(
        (res) => ({
          url: (res.data && res.data.url) || null,
          available: !!(res.data && res.data.available),
          contentType: (res.data && res.data.contentType) || null,
          fileName: (res.data && res.data.fileName) || null,
        }),
        (error) => Promise.reject(error)
      );
  };
};

/**
 * The input document behind a patient's latest report in a Strapi collection:
 * look up the record's `report_id`, then resolve that report's input url.
 * @param {string} collection Strapi collection slug (e.g. "clinical-blood-reports")
 * @param {string} phone      Patient phone (10-digit, matches Strapi patient_phone)
 * @returns {Promise<{ url: string|null, available: boolean }>}
 */
export const getReportInputUrlRequest = (collection, phone) => {
  return (dispatch) => {
    if (!collection || !phone) return Promise.resolve(EMPTY_REPORT_INPUT);
    const url = `/${collection}?filters[patient_phone][$eq]=${phone}&sort=updatedAt:desc&pagination[page]=1&pagination[pageSize]=1`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then((res) => {
        const record = (res.data && res.data.data && res.data.data[0]) || null;
        // Strapi v4 nests fields under `attributes`; v5 keeps them flat.
        const attributes = record ? record.attributes || record : null;
        const reportId = attributes && attributes.report_id;
        if (!reportId) return Promise.resolve(EMPTY_REPORT_INPUT);
        return dispatch(getDxaiReportInputUrlRequest(reportId));
      });
  };
};

/**
 * Resolve the current, viewable PDF url for a patient's latest report in a Strapi
 * collection: look up the record's `report_id`, then ask the DXAI service to
 * re-sign a fresh link (the stored `pdf_url` expires and is not used any more).
 * GET /{collection}?filters[patient_phone][$eq]={phone}&sort=updatedAt:desc&pagination[pageSize]=1
 * @param {string} collection Strapi collection slug (e.g. "clinical-blood-reports")
 * @param {string} phone      Patient phone (10-digit, matches Strapi patient_phone)
 * @returns {Promise<{ url: string|null, reportId: string|null }>}
 */
export const getFreshReportUrlRequest = (collection, phone) => {
  return (dispatch) => {
    const url = `/${collection}?filters[patient_phone][$eq]=${phone}&sort=updatedAt:desc&pagination[page]=1&pagination[pageSize]=1`;
    return new HttpRequest(dispatch, url, "get")
      .thirdPartyIntegration(STRAPI_API_URL)
      .then((res) => {
        const record = (res.data && res.data.data && res.data.data[0]) || null;
        // Strapi v4 nests fields under `attributes`; v5 keeps them flat.
        const attributes = record ? record.attributes || record : null;
        const reportId = attributes && attributes.report_id;
        if (!reportId) return Promise.resolve({ url: null, reportId: null });
        return dispatch(getDxaiReportUrlRequest(reportId)).then((freshUrl) => ({
          url: freshUrl,
          reportId,
        }));
      });
  };
};

/**
 * Resolve the current, viewable PDF url for a patient's latest chatbot report of
 * a given type (e.g. "symptom_analyzer"). Picks the most recent report that
 * carries a usable signed `pdf_url`.
 * GET /reports/by-user?phone={phone}&type={type}
 * @returns {Promise<{ url: string|null, reportId: string|null }>}
 */
export const getChatbotReportUrlRequest = (phone, type) => {
  return (dispatch) => {
    if (!phone) return Promise.resolve({ url: null, reportId: null });
    const url = `reports/by-user?phone=${encodeURIComponent(
      phone
    )}&type=${encodeURIComponent(type)}`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        const reports = (res.data && res.data.reports) || [];
        const picked = reports
          .filter((r) => r && r.pdf_url)
          .sort((a, b) =>
            String(b.report_date || "").localeCompare(String(a.report_date || ""))
          )[0];
        return Promise.resolve({
          url: picked ? picked.pdf_url : null,
          reportId: picked ? picked.report_id : null,
        });
      },
      (error) => Promise.reject(error)
    );
  };
};

// A patient's chatbot reports with full payloads, in one call. `type=chatbot`
// returns all report_types; callers filter client-side. Returns [] if none.
export const getChatbotReportsRequest = (phone) => {
  return (dispatch) => {
    if (!phone) return Promise.resolve([]);
    const url = `reports/by-user?phone=${encodeURIComponent(
      phone
    )}&type=chatbot&include_payload=1`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => Promise.resolve((res.data && res.data.reports) || []),
      (error) => Promise.reject(error)
    );
  };
};

/**
 * Fetch a patient's saved assessment session (12-module results) via our backend
 * proxy. Returns the session object ({ phone, module_results, classical_reports }).
 * GET /assessment/session/{phone}
 */
export const getAssessmentSessionRequest = (phone) => {
  return (dispatch) => {
    if (!phone) return Promise.resolve(null);
    return new HttpRequest(
      dispatch,
      `assessment/session/${encodeURIComponent(phone)}`,
      "get"
    )
      .send()
      .then(
        (res) => Promise.resolve(res.data || null),
        (error) => Promise.reject(error)
      );
  };
};

/**
 * Replace a patient's saved assessment module results (bulk edit) via our backend.
 * PUT /assessment/session/{phone}   body: { module_results, classical_reports? }
 */
export const saveAssessmentSessionRequest = (phone, body) => {
  return (dispatch) => {
    if (!phone) return Promise.reject(new Error("Missing phone"));
    dispatch(showLoader());
    return new HttpRequest(
      dispatch,
      `assessment/session/${encodeURIComponent(phone)}`,
      "put",
      body
    )
      .send()
      .then(
        (res) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Assessment saved", "success"));
          return Promise.resolve(res.data);
        },
        (error) => {
          dispatch(hideLoader());
          dispatch(showSnackbar("Failed to save assessment", "error"));
          return Promise.reject(error);
        }
      );
  };
};

/**
 * Rebuild a patient's comprehensive assessment report from the saved module data,
 * via our backend proxy. Slow (~30-70s); the caller shows its own loading state,
 * so no global loader here — just a success/failure snackbar.
 * POST /assessment/session/{phone}/regenerate
 */
export const regenerateAssessmentReportRequest = (phone) => {
  return (dispatch) => {
    if (!phone) return Promise.reject(new Error("Missing phone"));
    return new HttpRequest(
      dispatch,
      `assessment/session/${encodeURIComponent(phone)}/regenerate`,
      "post",
      {}
    )
      .send()
      .then(
        (res) => {
          dispatch(showSnackbar("Report regenerated", "success"));
          return Promise.resolve(res.data);
        },
        (error) => {
          dispatch(showSnackbar("Failed to regenerate report", "error"));
          return Promise.reject(error);
        }
      );
  };
};

export const getAssessmentComprehensiveReportRequest = (phone) => {
  return (dispatch) => {
    if (!phone) return Promise.resolve(null);
    return new HttpRequest(
      dispatch,
      `assessment/comprehensive/reports/${encodeURIComponent(phone)}`,
      "get"
    )
      .send()
      .then(
        (res) => Promise.resolve((res.data && res.data.payload) || null),
        (error) => Promise.reject(error)
      );
  };
};

export const getAssessmentQuestionsRequest = (moduleId) => {
  return (dispatch) => {
    if (!moduleId) return Promise.resolve(null);
    return new HttpRequest(
      dispatch,
      `assessment/${encodeURIComponent(moduleId)}/questions`,
      "get"
    )
      .send()
      .then(
        (res) => Promise.resolve(res.data || null),
        (error) => Promise.reject(error)
      );
  };
};

export const calculateAssessmentModuleRequest = (moduleId, body) => {
  return (dispatch) => {
    if (!moduleId) return Promise.reject(new Error("Missing moduleId"));
    return new HttpRequest(
      dispatch,
      `assessment/${encodeURIComponent(moduleId)}/calculate`,
      "post",
      body
    )
      .send()
      .then(
        (res) => Promise.resolve(res.data || null),
        (error) => Promise.reject(error)
      );
  };
};

/**
 * function to get signed url
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getSignedUrlRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patients/profilePic/signedURL`;
    return new HttpRequest(dispatch, url, "post", data)
      .send()
      .then((res) => {
        dispatch(hideLoader());
        return Promise.resolve(res.data.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      });
  };
};

/**
 * function to upload to signed url
 * @param url: url for api request
 * @param file: file for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const uploadToS3Request = (url, file) => {
  return (dispatch) => {
    dispatch(showLoader());
    return new HttpRequest(dispatch, url, "put", file)
      .s3Upload()
      .then((res) => {
        dispatch(hideLoader());
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      });
  };
};

export const searchPatientsRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());

    // Key insight: Your API seems to return results with numbers but not with empty string
    // Send a special character or digit for empty search
    const searchTerm = data.trim() === "" ? "0" : data;

    const url = `patient/search/madmachine?search=${encodeURIComponent(
      searchTerm
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(searchPatients(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getPatientsSymptom = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patient/symptom/history?userId=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(patientSymptom(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getPatientImageAnalysisStore = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patient/symptom/imageAnalysisStore?userId=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(patientImageAnalysisStore(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getPatientQuestionAnswer = (type, userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patient/score/questionsWithAnswers?scoreName=${type}&userId=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(patientQuestionAnswer(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getClinicalSummaryRequest = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patient/score/questionsWithAnswers/analytics?userId=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(setClinicalSummary(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getVikrutiDataRequest = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `vikrutiData?user_id=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(setVikrutiData(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getBloodReportDataRequest = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `bloodReport?user_id=${userId}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(setBloodReportData(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getVikrutiAverageData = (userId, dayType) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `patient/readings/vikruti?user_id=${userId}&dayType=${dayType}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(setVikrutiAverageData(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getSymptomsDataRequest = (userId) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `patient/score/questionsWithAnswers/assesment?userId=${userId}`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(setSymptomsData(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};
